var _style, _defs, _g, _defs2, _g2, _defs3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqDice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    enableBackground: "new 0 0 30 30",
    height: 30,
    width: 30,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_4_);}\n\t.st3{clip-path:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    className: "st0",
    points: "26,4.1 27,22.9 8.5,23.2 7.5,4.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,21.3c-0.6,0-1.1-0.5-1.1-1.1l-0.7-13c0-0.6,0.4-1.1,1-1.1l12.8-0.2c0.6,0,1.1,0.5,1.1,1.1L25,20 c0,0.6-0.4,1.1-1,1.1L11.3,21.3 M26,4.1L7.5,4.4l1,18.8L27,22.9c0,0-0.1-0.9-0.1-2L26,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,17.3c-0.5,0-0.8,0.2-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.4,1.2,0.4 c0.5,0,0.9-0.2,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1c0-0.4-0.2-0.8-0.5-1.1C18.2,17.4,17.8,17.3,17.3,17.3 M16.9,7 c-1.3,0-2.3,0.4-3,1c-0.7,0.7-1,1.6-1,2.8l3-0.1c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.4,0.8-0.4c0.8,0,1.2,0.4,1.2,1.3 c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.7-0.9,1c-0.4,0.4-0.7,0.8-0.9,1.3c-0.2,0.5-0.2,1.2-0.2,2.1l2.5,0 c0-0.4,0-0.8,0.1-1.1c0.1-0.3,0.3-0.6,0.6-0.9l1-1c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.4,0.2-0.9,0.2-1.4 c-0.1-1.1-0.5-2-1.2-2.6C19.3,7.3,18.2,7,16.9,7"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    className: "st0",
    points: "27,22.9 22.5,25.6 4,25.9 8.5,23.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.7,23.2c0.6,0,0.9,0.1,0.8,0.1l-3.1,1.9c-0.1,0.1-0.7,0.2-1.3,0.2L7.3,25.6c-0.6,0-0.9-0.1-0.8-0.1l3.1-1.9 c0.1-0.1,0.7-0.2,1.3-0.2L23.7,23.2 M4,25.9l18.5-0.3l4.5-2.7L8.5,23.2c0,0-0.2,0.1-0.5,0.3L4,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,23.9c0.5,0,0.9,0,1.3-0.1c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0-0.1-0.2-0.1c-0.2,0-0.6,0-1.1,0 c-0.5,0-0.9,0-1.3,0.1c-0.4,0-0.6,0.1-0.7,0.2c-0.1,0.1,0,0.1,0.2,0.1C15.6,23.9,16,23.9,16.5,23.9 M13.9,25.4 c1.3,0,2.4-0.1,3.3-0.2c0.9-0.1,1.5-0.2,1.8-0.4l-3,0.1c-0.1,0.1-0.3,0.1-0.6,0.2c-0.3,0-0.6,0.1-0.9,0.1 c-0.8,0-1,0-0.8-0.2c0.1-0.1,0.3-0.1,0.6-0.2c0.3,0,0.7-0.1,1.2-0.2c0.5-0.1,0.9-0.1,1.3-0.2c0.3-0.1,0.6-0.2,0.8-0.3 l-2.5,0c-0.1,0.1-0.3,0.1-0.4,0.2c-0.2,0-0.4,0.1-0.8,0.1l-1.2,0.2c-0.5,0.1-0.9,0.1-1.2,0.2c-0.3,0.1-0.5,0.1-0.6,0.2 c-0.3,0.2-0.1,0.3,0.4,0.4C11.6,25.4,12.6,25.4,13.9,25.4"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_5_",
    className: "st0",
    points: "8.5,23.2 4,25.9 3,7.1 7.5,4.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,20.6c0,0.6-0.1,1.2-0.2,1.2l-3.1,1.9c-0.1,0.1-0.3-0.3-0.3-0.9l-0.7-13c0-0.6,0.1-1.2,0.2-1.2l3.1-1.9 C7.1,6.5,7.2,7,7.2,7.6L7.9,20.6 M3,7.1l1,18.8l4.5-2.7l-1-18.8c0,0-0.2,0.1-0.5,0.3L3,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,14.7c0,0.5,0.1,0.8,0.2,1.1c0.1,0.3,0.2,0.4,0.3,0.3c0.1-0.1,0.2-0.3,0.2-0.6c0.1-0.4,0.1-0.8,0-1.2 c0-0.5-0.1-0.9-0.2-1.1c-0.1-0.3-0.2-0.4-0.3-0.3c-0.1,0.1-0.2,0.3-0.2,0.6C6.6,13.9,6.6,14.3,6.6,14.7 M4.2,16.1 c0.1,1.3,0.2,2.3,0.4,3c0.2,0.6,0.4,0.9,0.7,0.7l-0.2-3c-0.1,0.1-0.2,0-0.3-0.2c-0.1-0.2-0.1-0.5-0.1-0.8 c0-0.8,0-1.2,0.3-1.4c0.1-0.1,0.2,0,0.3,0.2c0.1,0.2,0.2,0.5,0.3,0.9c0.1,0.4,0.2,0.6,0.4,0.8c0.1,0.1,0.3,0.1,0.5,0 l-0.1-2.6c-0.1,0.1-0.2,0-0.3,0c-0.1-0.1-0.2-0.2-0.2-0.5l-0.3-0.9c-0.1-0.4-0.2-0.6-0.3-0.8c-0.1-0.1-0.2-0.2-0.3-0.1 c-0.3,0.2-0.5,0.7-0.6,1.5C4.1,13.7,4.1,14.8,4.2,16.1"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqDice);
export default __webpack_public_path__ + "static/media/FaqDice.2f830892c5557df19cd236a7011eeffe.svg";
export { ForwardRef as ReactComponent };